import type { MailboxInfo } from "owa-client-types";
import type { UserConfigurationArgs } from "owa-graph-schema";
import { updateAccountScopeUserSettings } from "owa-session-store/lib/actions/updateAccountScopeUserSettings";
import { createUserConfigurationUpdateFunction } from "./createUserConfigurationUpdateFunction";
import { type UpdateOperationType, updateOperationMap } from "./updateUserConfigurationTypes";

export function updateAccountScopeUserSettingsAndService(mailboxInfo: MailboxInfo, updates: UserConfigurationArgs, updateOperationType: UpdateOperationType = "UserConfiguration"): Promise<unknown> {
    updateAccountScopeUserSettings(mailboxInfo, createUserConfigurationUpdateFunction(updates));
    
    return updateOperationMap[updateOperationType].importAndExecute(mailboxInfo, updates);
}
